export { default } from './carousel-wrapper.component'
export type { WrapperProps } from './carousel-wrapper.component'
